/**
 * TileSelect Component
 *
 * Visual selectable tiles for options.
 *
 * @package PresszoneComments
 */

import { el } from '../utils/dom.js';

/**
 * Render a tile selection grid.
 *
 * @param {string} key - State key
 * @param {string} label - Field label
 * @param {string} help - Tooltip help text
 * @param {Array} options - Array of { value, label, default?, preview? } objects
 * @param {Object} state - State object containing value
 * @param {Function} onUpdate - Callback when value changes
 * @param {Object} props - Additional properties { layout: 'grid' | 'compact' }
 */
export function TileSelect(key, label, help, options, state, onUpdate, props = {}) {
    const { layout = 'grid' } = props;
    const currentValue = state[key] || options.find(o => o.default)?.value || options[0]?.value;

    const gridClass = layout === 'compact'
        ? 'presszone-comments-tile-grid presszone-comments-tile-grid--compact'
        : 'presszone-comments-tile-grid';

    return el('div', { class: 'presszone-comments-form-group' },
        el('label', { class: 'presszone-comments-label--settings', for: key },
            label,
            help ? el('span', { class: 'presszone-comments-tooltip', title: help }, 'i') : null
        ),
        el('div', { class: gridClass },
            ...options.map(opt => {
                const isActive = currentValue === opt.value;

                return el('button', {
                    type: 'button',
                    class: `presszone-comments-tile ${isActive ? 'presszone-comments-tile--active' : ''} presszone-comments-tile--${opt.value}`,
                    'aria-pressed': isActive,
                    'aria-label': opt.label,
                    onclick: (e) => {
                        console.log(`[TileSelect] Clicked: key="${key}", value="${opt.value}"`);
                        state[key] = opt.value;
                        console.log(`[TileSelect] State updated: state[${key}] = "${state[key]}"`);
                        if (onUpdate) onUpdate(key, opt.value);

                        // Visual update without full re-render
                        const button = e.currentTarget;
                        const siblings = Array.from(button.parentNode.children);
                        siblings.forEach(sib => {
                            sib.classList.remove('presszone-comments-tile--active');
                            sib.setAttribute('aria-pressed', 'false');
                        });
                        button.classList.add('presszone-comments-tile--active');
                        button.setAttribute('aria-pressed', 'true');
                    }
                },
                    opt.preview ? opt.preview : el('span', { class: 'presszone-comments-tile__preview' }),
                    el('span', { class: 'presszone-comments-tile__label' }, opt.label)
                );
            })
        )
    );
}

export default TileSelect;
